import {connect} from 'react-redux'
import {List} from 'immutable'

import BaseItemPermissionsContainer from '../shared/BaseItemPermissionsContainer'
import {findRawResourceByAttributeId} from '../../../../../lib/plan_data/userData'
import {selectAllItemIds} from '../../../../../lib/plan_data/itemSelectors'
import {currentUserConfig} from '../../../../../lib/userTools'


const QuarterbackItemPermissionsContainer = props => (
  <BaseItemPermissionsContainer {...props} />
)

const mapStateToProps = (state, ownProps) => {
  const {api} = state
  const userConfig = currentUserConfig(api)

  const requestItemPermissionsInvite = findRawResourceByAttributeId({
    rawResource: api['quarterback-request-item-permissions-invites'],
    attribute: 'everplan-id',
    id: ownProps.everplanSummary.get('id')
  })

  return {
    userConfig,
    requestItemPermissionsInvite,
    firmConfig: findRawResourceByAttributeId({
      rawResource: api['firm-configs'],
      attribute: 'firm-id',
      id: ownProps.quarterbackOwnership.get('ownable-id')
    }),
    ownership: ownProps.quarterbackOwnership,
    allItemIds: selectAllItemIds(state),
    defaultRequestItemPermissionIds: ownProps.quarterbackOwnership.get('edit-item-ids', List()).toArray(),
    inviteType: 'quarterback-request-item-permissions-invites'
  }
}

export default connect(mapStateToProps)(QuarterbackItemPermissionsContainer)
